function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { $window, isMini } from '@antv/l7-utils'; // @ts-ignore

import UnitBezier from '@mapbox/unitbezier';
var reducedMotionQuery;
export function wrap(n, min, max) {
  var d = max - min;
  var w = ((n - min) % d + d) % d + min;
  return w === min ? max : w;
}
export function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
}
export function interpolate(a, b, t) {
  return a * (1 - t) + b * t;
}
export function bezier(p1x, p1y, p2x, p2y) {
  var bez = new UnitBezier(p1x, p1y, p2x, p2y);
  return function (t) {
    return bez.solve(t);
  };
}
export var ease = bezier(0.25, 0.1, 0.25, 1);
export function prefersReducedMotion() {
  // @ts-ignore
  if (isMini || !$window.matchMedia) {
    return false;
  } // Lazily initialize media query


  if (reducedMotionQuery == null) {
    // @ts-ignore
    reducedMotionQuery = $window.matchMedia('(prefers-reduced-motion: reduce)');
  }

  return reducedMotionQuery.matches;
}
export function pick(src, properties) {
  var result = {};

  var _iterator = _createForOfIteratorHelper(properties),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var name = _step.value;

      if (name in src) {
        result[name] = src[name];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}
export var now = isMini ? Date.now.bind(Date) : $window.performance && $window.performance.now ? $window.performance.now.bind($window.performance) : Date.now.bind(Date);
export var raf = $window.requestAnimationFrame || // @ts-ignore
$window.mozRequestAnimationFrame || // @ts-ignore
$window.webkitRequestAnimationFrame || // @ts-ignore
$window.msRequestAnimationFrame;

var _cancel = $window.cancelAnimationFrame || // @ts-ignore
$window.mozCancelAnimationFrame || // @ts-ignore
$window.webkitCancelAnimationFrame || // @ts-ignore
$window.msCancelAnimationFrame;

export { _cancel as cancel };
export function renderframe(fn) {
  var frame = raf(fn);
  return {
    cancel: function cancel() {
      return _cancel(frame);
    }
  };
}